import { type FC } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsInfoCircle } from 'react-icons/bs';

import { validationInfoContent } from '@editor2/services/elementValidationsService';

interface Props {
	validationName: string;
}

export const InfoTooltip: FC<Props> = (props) => {
	const { validationName } = props;
	return (
		<OverlayTrigger
			overlay={<Tooltip id={validationName}>{validationInfoContent[validationName]}</Tooltip>}>
			<BsInfoCircle className="info" />
		</OverlayTrigger>
	);
};
